(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gd-drop-hero-video')) {
  customElements.define('gd-drop-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.gd-drop-hero__video-toggle');
      this.frame = this.querySelector('.gd-drop-hero__video-frame');
      if (!this.button || !this.frame) return;
      this.abort = new AbortController();
      this.desktop = matchMedia('(min-width: 750px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.intent = null;
      this.video = null;
      this.activeID = null;
      this.generation = 0;
      this.inView = !('IntersectionObserver' in window);
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.intent = !this.video || this.video.paused;
        this.sync();
      }, { signal: this.abort.signal });
      this.desktop.addEventListener('change', () => this.sync(), { signal: this.abort.signal });
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.intent = null;
        this.sync();
      }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal: this.abort.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        });
        this.observer.observe(this.querySelector('.gd-drop-hero__art'));
      }
      this.sync();
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      this.clearVideo();
    }

    clearVideo() {
      this.generation += 1;
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video.remove();
      }
      this.video = null;
      this.activeID = null;
      if (this.frame) this.frame.hidden = true;
    }

    setPlaying(playing) {
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      this.button.querySelector('[data-drop-play]').hidden = playing;
      this.button.querySelector('[data-drop-pause]').hidden = !playing;
    }

    sync() {
      if (!this.isConnected) return;
      const template = this.querySelector(this.desktop.matches ? '[data-drop-video-desktop]' : '[data-drop-video-mobile]');
      if (!template) return;
      if (this.activeID !== template.dataset.videoId) this.clearVideo();
      const shouldPlay = !document.hidden && this.inView && this.intent !== false && (this.intent === true || !this.reduced.matches);
      if (!shouldPlay) {
        if (this.video) this.video.pause();
        this.setPlaying(false);
        return;
      }
      if (!this.video) {
        const original = template.content.querySelector('video');
        if (!original) { this.button.hidden = true; return; }
        const video = original.cloneNode(true);
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.removeAttribute('autoplay');
        const generation = ++this.generation;
        const current = () => this.isConnected && this.generation === generation;
        video.addEventListener('playing', () => {
          if (!current()) return;
          this.frame.hidden = false;
          this.setPlaying(true);
        });
        video.addEventListener('pause', () => {
          if (current()) this.setPlaying(false);
        });
        video.addEventListener('error', () => {
          if (!current()) return;
          this.frame.hidden = true;
          this.intent = false;
          this.setPlaying(false);
        });
        this.video = video;
        this.activeID = template.dataset.videoId;
        this.frame.replaceChildren(video);
      }
      const video = this.video;
      const generation = this.generation;
      if (!video.paused) return;
      this.frame.hidden = false;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {
        if (this.isConnected && this.generation === generation && video.paused) {
          this.frame.hidden = true;
          this.setPlaying(false);
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
